import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import DialogBox from '../DialogBox';
import ConfettiDiv from './ConfettiDiv';
import backgroundImage from '../../images/complete-page-bg.png';
import dashboardIcon from '../../images/dashboard-icon';
import laptopIcon from '../../images/laptop-icon';
import searchIcon from '../../images/search-icon';
import {SVGIcon} from '@homeaway/react-svg';
import appActions from '../../actions/actions';
import userInfoActions from '../../actions/userInfo';
import {getCompletePageContents} from '../utils/completePageUtil';
import {get} from 'lodash';
import './styles';
import {isPPM} from '../../utils/validate';
import ActivationProcessDiagram from './activationProcessDiagram';
import gqlEligibilityAction from '../../actions/gqlEligibility';

function mapStateToProps(state) {
    return {
        publicUuid: (typeof (state.app.publicUuid) === 'undefined') ? '' : state.app.publicUuid,
        translations: state.app.translations,
        brandName: state.system.brandName,
        firstName: get(state, 'gqlEligibility.metadata.accountInfo.user.firstName', ''),
        systemId: get(state, 'userInfoDetails.userInfoMetadata.ipm.externalSystemId', ''),
        gqlUserType: get(state, 'gqlEligibility.metadata.accountInfo.pmType', ''),
        siteName: state.system.siteName,
        isSWSv2FlowEnabled: get(state, 'app.isSWSv2FlowEnabledFlag', ''),
        isGQLEligible: get(state, 'gqlEligibility.metadata.partnerScopes',''),
        userType: get(state, 'app.userType', ''),
        businessModel: get(state, 'userInfoDetails.userInfoMetadata.businessModel', ''),
        dyff: get(state,'app.dyff', {}),
        environment: state.system.environment,
        // TODO: Check if gqlUserType is unique or if it is the same as userType result
    };
}

function mapDispatchToProps(dispatch) {
    return {
        appActions: bindActionCreators(appActions, dispatch),
        userInfoActions: bindActionCreators(userInfoActions, dispatch),
        gqlEligibilityAction: bindActionCreators(gqlEligibilityAction, dispatch),
        dispatch
    };
}

@connect(mapStateToProps, mapDispatchToProps)
export default class Complete extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            height: 0,
            width: 0
        };
        this.updateDimensions = this.updateDimensions.bind(this);
    }

    componentWillMount() {
        this.props.userInfoActions.getUserInfo();
        if (!this.props.firstName) {
            this.props.appActions.enableLoadOverLay(true);
            this.props.gqlEligibilityAction.getGQLEligiblity();
        }

        this.props.appActions.deleteComponentState();
        if (!this.props.isSWSv2FlowEnabled) {
            this.props.appActions.getAbacusExpFlag(['vrbo_qc_sws_v2_flow'], this.props.siteName);
        }
    }

    componentDidMount() {
        const {publicUuid} = this.props;

        this.props.appActions.triggerEdapPageView(publicUuid, 'Completed Page');
        this.updateDimensions();
        window.addEventListener('resize', this.updateDimensions);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions);
    }

    updateDimensions() {
        const checklistCompleteElement = document.querySelector('.complete-pg');
        const height = checklistCompleteElement.clientHeight;
        const width = checklistCompleteElement.clientWidth;
        this.setState({height, width});
    }

    render() {
        const {translations, gqlUserType, brandName, isSWSv2FlowEnabled, siteName, isGQLEligible, userType, businessModel, systemId, environment} = this.props;
        const ipmBankingEnabled = this.props.dyff?.SHARED_IPM_BANKING_ENABLED
        const {contents, dialogHeading, heading, dialogFooter, footer, actionLabel, handleSubmit} = getCompletePageContents(gqlUserType, translations, brandName, isSWSv2FlowEnabled, siteName, isGQLEligible, userType, businessModel, ipmBankingEnabled, systemId, environment);
        return (
            <div className="complete-pg">
                <div className="complete-pg-wrapper">
                    <img className="complete-pg-bg-img" src={backgroundImage()}/>
                    <ConfettiDiv width={this.state.width} height={this.state.height} />
                    <DialogBox
                        heading={heading}
                        actionLabel={actionLabel}
                        handleSubmit={handleSubmit}
                        dialogHeading={dialogHeading}
                        contents={contents}
                        dialogFooter={dialogFooter}
                        footer={footer}
                        styles={{width: 663, height: 300, innerPadding: (isGQLEligible && !ipmBankingEnabled) ? 10 : 72, outerPaddingTop: 10, outerPaddingBottom: 10}}
                        isGql={isGQLEligible}
                    />
                    {(isPPM(gqlUserType) && !isGQLEligible) ? <ActivationProcessDiagram {...this.props}/> : null}
                    <div className="resources-wrapper"><div className="illustration-divider" /></div>
                    <div className="resources-wrapper">
                        <h3 className="helpful-resources-heading">
                            {translations['ipmob.complete.helpful.resources']}
                        </h3>
                        <div className="helpful-resources holder">
                            <div className="helpful-resource-item">
                                <div className="resource-icon-holder" ><SVGIcon className="resource-icon" markup={laptopIcon}/></div>
                                <div className="resource-label"><a target="_blank" rel="noopener noreferrer" href={translations['ipmob.complete.helpful.resource.1.link']}>{translations['ipmob.complete.helpful.resource.1']}</a></div>
                            </div>
                            <div className="helpful-resource-item">
                                <div className="resource-icon-holder"><SVGIcon className="resource-icon" markup={dashboardIcon}/></div>
                                <div className="resource-label"><a target="_blank" rel="noopener noreferrer" href={translations['ipmob.complete.helpful.resource.2.link']}>{translations['ipmob.complete.helpful.resource.2']}</a></div>
                            </div>
                            <div className="helpful-resource-item">
                                <div className="resource-icon-holder"><SVGIcon className="resource-icon" markup={searchIcon}/></div>
                                <div className="resource-label"><a target="_blank" rel="noopener noreferrer" href={translations['ipmob.complete.helpful.resource.3.link']}>{translations['ipmob.complete.helpful.resource.3']}</a></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
